import { createFileRoute } from '@tanstack/react-router';

type Search = {
  checkOnboarding?: boolean;
  locationIds?: string[] | undefined;
  orgId?: string | undefined;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/home/dashboard')({
  staticData: { team: 'fe-ux-platform' },
  validateSearch: (search: Search): Search => {
    return {
      ...search,
      checkOnboarding: search.checkOnboarding ? true : undefined,
      ...(search.orgId ? { orgId: search.orgId } : {}),
      ...(search.locationIds ? { locationIds: search.locationIds } : {}),
    };
  },
});
